// Shown on the English home page, in the language the device prefers, so it
// can't use that page's messages.
export const BANNER_TEXT = {
  fr: {
    text: "PokeGrid est aussi disponible en français.",
    accept: "Jouer en français",
    dismiss: "Non merci",
  },
  de: {
    text: "PokeGrid gibt es auch auf Deutsch.",
    accept: "Auf Deutsch spielen",
    dismiss: "Nein danke",
  },
  es: {
    text: "PokeGrid también está disponible en español.",
    accept: "Jugar en español",
    dismiss: "No, gracias",
  },
};
